import State from './State';

/**
 * Getters are used to calculate values based off state. They are generally
 * used for filtering or formatting data.
 *
 * @class Getters
 * @package Store/Module/UserGuidance
 * @project ChalkySticks SDK Vue2.0 Components
 */
const getters = {
	/**
	 * @param State state
	 * @return boolean
	 */
	foo(state: typeof State): boolean {
		return !!state.foo;
	},

	/**
	 * Check if a coach mark has been seen
	 *
	 * @param State state
	 * @return (coachMarkId: string) => boolean
	 */
	hasCoachMarkBeenSeen(state: typeof State): (coachMarkId: string) => boolean {
		return (coachMarkId: string): boolean => {
			return state.coachMarksSeen.includes(coachMarkId);
		};
	},

	/**
	 * Legacy alias for hasCoachMarkBeenSeen (for backwards compatibility)
	 *
	 * @param State state
	 * @return (tooltipId: string) => boolean
	 */
	hasTooltipBeenSeen(state: typeof State): (tooltipId: string) => boolean {
		return (tooltipId: string): boolean => {
			return state.coachMarksSeen.includes(tooltipId);
		};
	},
};

export default getters;
